const Video = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 26" fill="none">
      <path
        d="M13.5755 22.1218H6.7288C3.30547 22.1218 2.16797 19.8468 2.16797 17.5609V8.43925C2.16797 5.01592 3.30547 3.87842 6.7288 3.87842H13.5755C16.9988 3.87842 18.1363 5.01592 18.1363 8.43925V17.5609C18.1363 20.9843 16.988 22.1218 13.5755 22.1218Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1484 18.5251L18.1367 16.4126V9.57681L21.1484 7.46431C22.6217 6.43514 23.8351 7.06348 23.8351 8.87264V17.1276C23.8351 18.9368 22.6217 19.5651 21.1484 18.5251Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.457 11.9165C13.3545 11.9165 14.082 11.189 14.082 10.2915C14.082 9.39404 13.3545 8.6665 12.457 8.6665C11.5596 8.6665 10.832 9.39404 10.832 10.2915C10.832 11.189 11.5596 11.9165 12.457 11.9165Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Video;
